/**
 * Utility functions for managing the dialog live region for screen readers
 */

export const DIALOG_LIVE_REGION_ID = 'dialog-live-region';

/**
 * Injects a message to the dialog live region for screen readers.
 * @param message - The message to announce to screen readers
 */
export const injectToDialogLiveRegion = (message: string): void => {
  const liveRegion = document.getElementById(DIALOG_LIVE_REGION_ID);
  if (liveRegion) {
    liveRegion.textContent = message;
  }
};

/**
 * Clears the dialog's scoped live region.
 */
export const clearDialogLiveRegion = (): void => {
  const liveRegion = document.getElementById(DIALOG_LIVE_REGION_ID);
  if (liveRegion) {
    liveRegion.textContent = '';
  }
};

/**
 * Injects a message to the dialog live region and clears it after a delay
 * @param message - The message to announce to screen readers
 * @param delay - Time in milliseconds before clearing the message (default: 3000)
 */
export const announceToDialogLiveRegion = (
  message: string,
  delay: number = 3000,
): (() => void) => {
  injectToDialogLiveRegion(message);

  const timeoutId = setTimeout(() => {
    clearDialogLiveRegion();
  }, delay);

  return () => clearTimeout(timeoutId);
};
